import { atom } from "jotai";
import type { SidebarState } from "../../core/entities/sidebar/SidebarState";

export const isCollapsedAtom = atom<SidebarState["isCollapsed"] | null>(null);
export const isCollapsedHoveredStateAtom = atom(false);
